import { render } from "./award_total.vue?vue&type=template&id=13ef9f3c&scoped=true"
import script from "./award_total.vue?vue&type=script&lang=js"
export * from "./award_total.vue?vue&type=script&lang=js"

import "./award_total.vue?vue&type=style&index=0&id=13ef9f3c&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ef9f3c"]])

export default __exports__